import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { IconName } from '..';
import * as S from './styles';

const msgs = defineMessages({
  toggleIcon: {
    id: 'toggle_icon',
    defaultMessage: 'Toggle {iconName} button',
  },
  difficultWords: {
    id: 'difficult_words',
    defaultMessage: 'difficult words',
  },
  ignoreWords: {
    id: 'scenario_lesson_i_already_know_this',
    defaultMessage: 'I already know this',
  },
});

type IconToggleProps = {
  handleClick: () => void;
  handleKeyUp?: () => void;
  iconName: IconName;
  isSelected: boolean;
  disabled?: boolean;
};

export const IconToggle: FC<IconToggleProps> = ({
  handleClick,
  handleKeyUp,
  iconName,
  isSelected,
  disabled,
}) => {
  const intl = useIntl();
  const toggleIconText = intl.formatMessage(msgs.toggleIcon, {
    iconName: iconName.includes('difficultWords')
      ? intl.formatMessage(msgs.difficultWords)
      : intl.formatMessage(msgs.ignoreWords),
  });

  return (
    <S.IconWrapper
      onClick={handleClick}
      onKeyUp={handleKeyUp}
      aria-label={toggleIconText}
      disabled={disabled}
      data-testid={iconName}
      $active={isSelected}
    >
      <S.Icon name={iconName} />
    </S.IconWrapper>
  );
};
